<div class="container">
    <div class="main">
        <div class="header">
            {{ 'ops-dialog.title' | translate: { index: data.opsUnit.index } }}
        </div>
        <div class="column-container">
            <div class="subtitle">
                {{ 'ops-dialog.subtitle.information' | translate }}
            </div>
            <div class="block">
                <div class="keyword-title">
                    {{ 'ops-dialog.input-subtitle.location' | translate }}
                </div>
                <app-system-setting-input
                    [name]="LOCATION"
                    label="ops-dialog.input-placeholder.location"
                    [value]="data?.opsUnit?.location"
                    [showLenCounter]="true"
                    (onInputChange)="onInputChange($event)"
                    [inputErrorMessage]="validationErrors.location?.message"
                    [showErrorMessage]="true"
                    [showErrorInitial]="data.isEditing || data.isDuplicating">
                </app-system-setting-input>
            </div>
            <div class="block extraPadding">
                <div class="keyword-title">
                    {{ 'ops-dialog.input-subtitle.category' | translate }}
                </div>
                <div class="multi-input-container">
                    <div
                        class="input-wrapper"
                        [class.selecting]="openCategoryList"
                        (click)="openSelect(); $event.stopImmediatePropagation()">
                        <input [value]="categoryLabel" readonly />
                        <div class="arrow-wrapper">
                            <mat-icon class="arrow" [class.focus]="openCategoryList" svgIcon="dropdown-arrow" />
                        </div>
                    </div>
                    <div *ngIf="openCategoryList" class="select-list-container" #categoryListContainer>
                        <div
                            *ngFor="let category of data.categoryList"
                            class="select-list"
                            [ngClass]="{selected: category.selected}"
                            (click)="selectCategory(category); $event.stopImmediatePropagation()">
                            <mat-checkbox class="checkbox" [checked]="category.selected"></mat-checkbox>
                            <div class="item" data-cy="input-multi-dropdown-option">
                                {{ category.category | slice: 0 : CATEGORY_MAX_LEN
                                }}{{ category.category.length > CATEGORY_MAX_LEN ? ELLIPSIS : '' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="block"
                [class.extraPadding]="!validationErrors.LineAIp?.message && !validationErrors.LineBIp?.message">
                <div class="keyword-title">
                    {{ 'ops-dialog.input-subtitle.address' | translate }}
                </div>
                <div class="ip-address">
                    <div class="line">
                        <div>
                            {{ 'ops-dialog.input-subtitle.a-line-ip' | translate }}
                        </div>
                        <app-system-setting-input
                            [name]="A_LINE_IP"
                            label="ops-dialog.input-placeholder.a-line-ip"
                            [value]="data?.opsUnit?.LineAIp"
                            (onInputChange)="onInputChange($event)"
                            [inputErrorMessage]="validationErrors.LineAIp?.message"
                            [showErrorMessage]="true"
                            [maxLength]="15">
                        </app-system-setting-input>
                    </div>
                    <div class="line">
                        <div>
                            {{ 'ops-dialog.input-subtitle.b-line-ip' | translate }}
                        </div>
                        <app-system-setting-input
                            [name]="B_LINE_IP"
                            label="ops-dialog.input-placeholder.b-line-ip"
                            [value]="data?.opsUnit?.LineBIp"
                            (onInputChange)="onInputChange($event)"
                            [inputErrorMessage]="validationErrors.LineBIp?.message"
                            [showErrorMessage]="true"
                            [maxLength]="15">
                        </app-system-setting-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="column-container">
            <div class="subtitle">
                {{ 'ops-dialog.subtitle.hardware' | translate }}
            </div>
            <div class="options-row">
                <div class="keyword-title options-title">
                    {{ 'ops-dialog.subtitle.hardware.mount' | translate }}
                </div>

                <ng-container
                    *ngTemplateOutlet="
                        radioGroupRow;
                        context: {
                            options: [
                                {
                                    value: CONSOLE,
                                    labelKey: 'ops-dialog.subtitle.hardware.console',
                                },
                                {
                                    value: STAND,
                                    labelKey: 'ops-dialog.subtitle.hardware.stand',
                                },
                            ],
                            value: data?.opsUnit?.mountType,
                            type: MOUNT_RADIO_BUTTON,
                            updateValue: updateRadioButtonValue,
                        }
                    "></ng-container>
            </div>

            <div class="options-row">
                <div class="keyword-title options-title">
                    {{ 'ops-dialog.subtitle.hardware.sunshade' | translate }}
                </div>
                <ng-container
                    *ngTemplateOutlet="
                        radioGroupRow;
                        context: {
                            options: [
                                {
                                    value: true,
                                    labelKey: 'ops-dialog.subtitle.hardware.required',
                                },
                                {
                                    value: false,
                                    labelKey: 'ops-dialog.subtitle.hardware.not-required',
                                },
                            ],
                            value: data?.opsUnit?.sunshade,
                            type: SUNSHADE_RADIO_BUTTON,
                            updateValue: updateRadioButtonValue,
                        }
                    "></ng-container>
            </div>
        </div>

        <div class="column-container">
            <div class="subtitle">
                {{ 'ops-dialog.subtitle.installation' | translate }}
            </div>

            <div class="options-row">
                <div class="keyword-title options-title">
                    {{ 'ops-dialog.subtitle.installation.emc' | translate }}
                </div>

                <ng-container
                    *ngTemplateOutlet="
                        radioGroupRow;
                        context: {
                            options: [
                                {
                                    value: true,
                                    labelKey: 'ops-dialog.subtitle.installation.required',
                                },
                                {
                                    value: false,
                                    labelKey: 'ops-dialog.subtitle.installation.not-required',
                                },
                            ],
                            value: data?.opsUnit?.EMC,
                            type: EMC_RADIO_BUTTON,
                            updateValue: updateRadioButtonValue,
                        }
                    "></ng-container>
            </div>

            <div class="options-row">
                <div class="keyword-title options-title">
                    {{ 'ops-dialog.subtitle.installation.ethernet' | translate }}
                </div>
                <ng-container
                    *ngTemplateOutlet="
                        radioGroupRow;
                        context: {
                            options: [
                                {
                                    value: false,
                                    labelKey: 'ops-dialog.subtitle.installation.short',
                                },
                                {
                                    value: true,
                                    labelKey: 'ops-dialog.subtitle.installation.long',
                                },
                            ],
                            value: data?.opsUnit?.ethernetExtraLength,
                            type: ETHERNET_RADIO_BUTTON,
                            updateValue: updateRadioButtonValue,
                        }
                    "></ng-container>
            </div>
        </div>

        <div class="column-container">
            <div class="subtitle">
                {{ 'ops-dialog.subtitle.operation' | translate }}
            </div>
            <div class="options-row">
                <div class="keyword-title options-title">
                    {{ 'ops-dialog.subtitle.operation.keyboard' | translate }}
                </div>
                <ng-container
                    *ngTemplateOutlet="
                        radioGroupRow;
                        context: {
                            options: [
                                {
                                    value: true,
                                    labelKey: 'ops-dialog.subtitle.operation.enabled',
                                },
                                {
                                    value: false,
                                    labelKey: 'ops-dialog.subtitle.operation.disabled',
                                },
                            ],
                            value: data?.opsUnit?.keyboard,
                            type: KEYBOARD_RADIO_BUTTON,
                            updateValue: updateRadioButtonValue,
                        }
                    "></ng-container>
            </div>
        </div>

        <div class="column-container">
            <div class="subtitle">
                <div>
                    {{ 'ops-dialog.subtitle.appearance' | translate }}
                </div>
                <div class="subtitle-extra">
                    {{ 'ops-dialog.subtitle.appearance-optional' | translate }}
                </div>
            </div>

            <div class="ip-address">
                <div class="line">
                    <div class="keyword-title">
                        {{ 'ops-dialog.appearance.color.title' | translate }}
                    </div>
                    <app-system-setting-input
                        [name]="COLOR"
                        label="ops-dialog.appearance.color.placeholder"
                        [value]="data?.opsUnit?.color"
                        (onInputChange)="onInputChange($event)"
                        [inputErrorMessage]="validationErrors.color?.message"
                        [showErrorMessage]="true"
                        [maxLength]="8"
                        [showLenCounter]="true">
                    </app-system-setting-input>
                </div>
            </div>
        </div>
    </div>
    <div class="footer">
        <button class="text-button" data-cy="ops-settings-system-setting-ops-modal-cancel-button" (click)="close()">
            {{ 'dlg.cancel' | translate }}
        </button>
        <app-button
            [disable]="isSaveButtonDisabled"
            [text]="data?.isEditing ? 'ops-dialog.button.save' : 'ops-dialog.button.create'"
            customFontFamily="NotoSans-SemiBold"
            size="small"
            customFontSize="14px"
            (onClick)="saveOps()"></app-button>
    </div>
</div>

<ng-template #radioGroupRow let-options="options" let-value="value" let-updateValue="updateValue" let-type="type">
    <div class="option-toggle-container">
        <mat-radio-group class="option-row" [value]="value" (change)="updateValue(type, $event.value)">
            @for (option of options; track option.value) {
                <mat-radio-button [value]="option.value">
                    {{ option.labelKey | translate }}
                </mat-radio-button>
            }
        </mat-radio-group>
    </div>
</ng-template>

<ng-container *ngIf="isLoading">
    <app-loading-spinner class="spinner-component" title="dlg.saving"></app-loading-spinner>
</ng-container>
